import React from 'react';
import { string as stringType, func } from 'prop-types';
import {
  useDataModel, shape, number,
} from '@thd-nucleus/data-sources';

import { SelectionControlLabel } from '@one-thd/sui-atomic-components';

const hasProtectionPlanData = (data) => {
  return data?.protectionPlan?.itemId && data?.protectionPlan?.price && data?.protectionPlan?.termLength;
};

const HdppItemOptionPod = ({
  key,
  itemId,
  optionsForProtectionPlan,
  handleChangeProPlan,
  Input,
  hdppSelectedItem,
  setIsHdppSelected,
  setErrorProtectionPlan,
  getDisplayPrice
}) => {
  let optionsForProtectionPlandata = optionsForProtectionPlan;
  optionsForProtectionPlandata.variables.protectionPlanParentId = itemId;
  const { data: protectionPlanData, loading: ppLoading } = useDataModel('protectionPlan', optionsForProtectionPlandata);

  if (ppLoading) {
    return null;
  }

  const isProtectionPlan = !!itemId && hasProtectionPlanData(protectionPlanData);
  if (!isProtectionPlan) {
    setErrorProtectionPlan((oldErrorArray) => {
      if (!oldErrorArray.includes(itemId)) {
        return [...oldErrorArray, itemId];
      }

      return oldErrorArray;

    });
    return null;
  }

  const {
    price,
    termLength
  } = protectionPlanData?.protectionPlan || {};
  const protItemID = protectionPlanData?.protectionPlan?.itemId;
  const priceReceived = price + '';

  const userSelectedHdpp = `hdpp-accept_${protItemID}`;
  return (
    <>
      <SelectionControlLabel
        label={<div data-id={key}>{`${termLength} Year / `}{getDisplayPrice(priceReceived)}</div>}
        value={userSelectedHdpp}
      >
        <Input
          id={`${userSelectedHdpp}__checkbox`}
          name={protItemID}
          checked={hdppSelectedItem === protItemID}
          onClick={() => {
            setIsHdppSelected(protItemID);
            handleChangeProPlan(protItemID);
          }}
        />
      </SelectionControlLabel>
    </>
  );

};

HdppItemOptionPod.propTypes = {
  itemId: stringType,
  key: number.isRequired,
  optionsForProtectionPlan: shape.isRequired,
  handleChangeProPlan: func.isRequired,
  Input: stringType.isRequired,
  setIsHdppSelected: func.isRequired,
  hdppSelectedItem: stringType,
  setErrorProtectionPlan: func.isRequired,
  getDisplayPrice: func.isRequired,
};

HdppItemOptionPod.defaultProps = {
  itemId: '0',
  hdppSelectedItem: '0',
};

export { HdppItemOptionPod };
